import {DataType, IPublisher} from '../ipublisher';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError, map} from 'rxjs/operators';
import {MsgContent} from '../../MessageContent/msg-content';
import {TypedJSON} from 'typedjson';
import {DataGrid} from '../../DoraData/data-grid';
import {IConfigurationCaller} from '../../Configuration/iconfiguration-caller';
import {DoraProperty} from '../../Decorators/Decorator';
import {Observable} from 'rxjs';
import {ComponentType} from '../../Configuration/component-type.enum';
import {IPublisherInitializer} from '../ipublisher-initializer';
import {ConfigurationService} from '../../Configuration/configuration-service';
import {DataRow} from 'src/app/DoraData/data-row';
import {DataSeries} from '../../DoraData/data-series';
import {ReadResult} from '../data/read-result';

declare function DoraGetLocale(): string;
declare function DoraGetProject(): string;

export class PublisherDataManagement implements IPublisher, IConfigurationCaller {

    @DoraProperty
    private baseUrl = '';
    @DoraProperty
    private project = '';

    private language = 'it'; // todo questo deve essere presa in get

    @DoraProperty
    private xlsxid = '';
    @DoraProperty
    private progressive = '1';


    private initializer: IPublisherInitializer = undefined;

    constructor(private http: HttpClient,
                progressive: string) {

        this.progressive = progressive;

        // set language
        this.language = DoraGetLocale();
    }

    // tslint:disable-next-line:ban-types
    read(publisherParameters: Map<string, string>, subscribeObjInfo: string[], dataType: DataType, callerData: any): Observable<Object> {
        const completeUrl = this.baseUrl +
            this.getParameterForUrl(publisherParameters) +
            '&dataId=' + subscribeObjInfo[0] + '&dataType=' + this.dataType2String(dataType);

        console.log('Call URL: ' + completeUrl);

        return this.http.jsonp(completeUrl, 'callback').pipe(map((data: any) => {

          let msgContent: MsgContent;
          // tslint:disable-next-line:prefer-const
          let serialized = new TypedJSON(MsgContent);

          msgContent = serialized.parse(data);

          if (msgContent.getError() !== '') {
            return null;
          }
          let readResult: ReadResult;

          switch (dataType) {
            case DataType.GRID: {
              let tableJson: string;
              tableJson = msgContent.getMultipleParameter('DataOut').getSingleParameter('value').getValue();

              // decode DataGrid
              let dataGrid: DataGrid;
              const dataGridSerialized = new TypedJSON(DataGrid);


              dataGrid = dataGridSerialized.parse(tableJson);
              readResult = new ReadResult(callerData, dataGrid);
              return readResult;
            }
            case DataType.ROW: {
              let contentJson: string;
              contentJson = msgContent.getMultipleParameter('DataOut').getSingleParameter('value').getValue();

              // decode DataGrid
              let dataRow: DataRow;
              const dataRowSerialized = new TypedJSON(DataRow);


              dataRow = dataRowSerialized.parse(contentJson);
              readResult = new ReadResult(callerData, dataRow);
              return readResult;
            }
            case DataType.HISTORICAL: {
              let contentJson: string;
              contentJson = msgContent.getMultipleParameter('DataOut').getSingleParameter('value').getValue();

              // decode DataSeries
              let dataSeries: DataSeries;
              const dataSeriesSerialized = new TypedJSON(DataSeries);


              dataSeries = dataSeriesSerialized.parse(contentJson);
              readResult = new ReadResult(callerData, dataSeries);
              return readResult;
            }
          }
          readResult = new ReadResult(callerData, '');
          return readResult;
        }),
            catchError((error: HttpErrorResponse) => {
                return '';
            }));
    }

    private dataType2String(dataType: DataType): string {

      switch (dataType) {
        case DataType.GRID:
          return 'Grid';
        case DataType.ROW:
          return 'Row';
        case DataType.HISTORICAL:
          return 'SeriesHistorical';
        default:
          return 'Type Undefined';
      }
    }

  // IConfigurationCaller methods
  // TODO bisogna costruire un servizio che istanzia queste classi e rendere parametrica questi parametri
  get CallerName(): string {
      return 'DataManager1';
  }
  get CallerProgressive(): string {
      return this.progressive;
  }
  get CallerSubType(): string {
      return 'DataManager';
  }
  get CallerType(): ComponentType {
      return ComponentType.Publishers;
  }

    setCallerProgressive(progressive: string): void {
        this.progressive = progressive;
    }

    initialize(initializer: IPublisherInitializer, configuration: ConfigurationService) {
      this.initializer = initializer;
      configuration.injectParametersToComponent(this);
    }

    getRewritableParameterMap(): Map<string, string> {
        const result: Map<string, string> = new Map<string, string>();

        result.set('project', this.project);
        result.set('language', this.language);
        result.set('xlsxid', this.xlsxid);
        return result;
    }

    private getParameterForUrl(parameters: Map<string, string>): string {
        let result = '';

        let first = true;
        parameters.forEach((value: string, key: string) => {
            if (first) {
                first = false;
                result += '?';
            } else {
                result += '&';
            }

            result += (key + '=' + value);
        });

        return result;
    }
  onParameterInjectedFinished(): void {
      // adjust baseurl
    // this.baseUrl += '?project=' + this.project + '&language=' + this.language + '&xlsxid=' + this.xlsxid;

    // get external project if any
    const externalProject = DoraGetProject();

    if (externalProject !== '') {
      this.project = externalProject;
    }

    // signal event
    this.initializer.onPublisherInitialized();
  }
}
